import { createApi } from '@/api/modules/utils'

const baseUrl = '/account/update_mobile'
const api = createApi(baseUrl)

// 账号相关
export const accountUpdateMobileApi = {
  sendCodeOld: api('send_code_old', 'get'),
  sendCodeNew: api('send_code_new', 'post'),
  updateBindMobile: api('update_bind_mobile', 'post'),
}